<p>new-user-login works!</p>
